import { Directive, HostListener, Output, EventEmitter, Input, Component, Injectable } from '@angular/core';
import { VideoControllerComponent } from '../../shell/video_controller/video_controller.component';
import { AudioControllerComponent } from '../../shell/audio_controller/audio_controller.component';
import { InteractiveComponent } from '../../components/interactivity/interactivity.component';
import { interActivityServices } from '../../shared/services/interactivity.services';
import { SliderControllerComponent } from '../../shell/slider_controller/slider_controller.component';
import * as activityDataObj from '../../shared/content/activityData.json';
declare var $;


import { AppGlobals } from '../../shared/app.global';

// import * as $ from 'jquery';

@Injectable()
@Directive({
  selector: "[click-directive]"
})

export class ClickDirective {
  public feedbackObj: any = null;
  public activityData = (<any>activityDataObj).activityData;

  constructor(
    public activityServices: interActivityServices,
    public sliderController: SliderControllerComponent,
    public videoCompo: VideoControllerComponent,
    public interactiveCompo: InteractiveComponent,
  ) {

  }
  @Input('click-directive') params: any;
  @HostListener('click', ['$event'])
  @HostListener("keydown", ['$event'])

  KeyboardEvent(event: KeyboardEvent) {
    if (event.type == "click" || (event.type == "keydown" && event.keyCode == 13 || event.keyCode == 32)) {
      this.handleClick(event);
    }
  }

  handleClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.params == "info_Btn"){
      this.popupBtnClick()
    }
    else if (this.params == "closeBtn") {
      this.closepopup()
    }
    else if (this.params == "playPauseBtn"){
      this.playPauseClick();
      $('.timeLineText').show();

    }
    else if (this.params == "audioOnOff"){
      this.audioOnOffClick();
    }
    else if (this.params == "resetButton") {
      this.activityServices.pauseVideo();
      this.activityServices.unMuteVideo();
      this.activityServices.videoElement.currentTime = 0;
      this.interactiveCompo.clickCounter= 0;
      this.activityServices.isVideoStarted = true;
      this.activityServices.isVideoEnded = false;
      this.activityServices.isShowPlay = true;
      this.activityServices.nextButton = true;
      this.activityServices.previousButton = true;
      $('#spanTimeline').html(this.activityData.videoTimeline[0].text);
      setTimeout(function(){
      $('.navigationButtons, #nextButton').addClass('disabledBtn');
      })
      this.activityServices.disableNextBtn();
      $('#nextButton,#prevButton').attr('tabindex', -1)
      let self = this;
      self.activityServices.videoTimelineTxt = "";
      setTimeout(function () {
        $("#playPauseBtn").attr("tabindex", 0)
      }, 50)
      if (self.activityServices.isShowPlay == true) {
        $('.resetBtnWrapper').addClass('disabledReset')
      }
      $('.timeLineText').hide();

    }

    // else if (this.params == "previousButton") {

    // }
    // else if (this.params == "nextButton") {

    // }
  }

  popupBtnClick():void {
    this.activityServices.isShowPopUp = true;
    if (this.activityServices.isShowPopUp) {
      setTimeout(function () {
        $(".introText").focus();
        $('.playBtnWrapper').addClass('disabledPlayPause');
      }, 30)
      this.activityServices.pauseVideo()
      this.activityServices.isShowPlay = true;
      this.activityServices.isVideoStarted = true;
      $('[tabindex=0]').attr('tabindex', -1)
      $('#nextButton').attr('tabindex', -1)
      $(".chapterText,.titleText,#info_Btn").attr("tabindex", 0);
    } else{
      if(this.activityServices.videoElement.currentTime == 0 || this.activityServices.isVideoEnded == true){
        this.activityServices.pauseVideo()
        this.activityServices.isShowPlay = true;
        if(this.activityServices.isVideoEnded == true){
          this.activityServices.isVideoStarted = false;
        }
        else{
          this.activityServices.isVideoStarted = true;
        }
      }else{
        this.activityServices.playVideo()
        this.activityServices.isShowPlay = false;
        setTimeout(function () {
          $("#resetButton").attr("tabindex", -1)
        }, 50)
      }
      this.activityServices.pauseVideo()
      this.activityServices.isShowPlay = true;
      this.activityServices.isVideoStarted = true;
      if (this.activityServices.isVideoEnded == true) {
        this.activityServices.isVideoStarted = false;
        setTimeout(function () {
          $("#playPauseBtn").attr("tabindex", -1)
        }, 50)
      }
      $('[tabindex=-1]').attr('tabindex', 0)
      if (this.activityServices.videoTimelineTxt){
        $("#spanTimeline").attr("tabindex",0)
      }else{
        $("#spanTimeline").attr("tabindex", -1)

      }
      if ($('.playBtnWrapper').hasClass('disabledPlayPause')) {
        $("#playPauseBtn").attr("tabindex", -1)
      }
      if ($('.resetBtnWrapper').hasClass('disabledReset')) {
        $("#resetButton").attr("tabindex", -1)
      }
    }
  }

  closepopup() {

    this.activityServices.isShowPopUp = false;
    $('[tabindex=-1]').attr('tabindex', 0);
    $('#nextButton').attr('tabindex', 0);
    $('.playBtnWrapper').removeClass('disabledPlayPause');
    if ($('.resetBtnWrapper').hasClass('disabledReset')) {
      $("#resetButton").attr("tabindex", -1)
    }
    if (this.activityServices.isVideoEnded == true) {
      $('.resetBtnWrapper').removeClass('disabledReset')
    }

  }

  playPauseClick():void {

    this.activityServices.isShowPlay = this.activityServices.isShowPlay ? false : true;
    this.activityServices.isShowPlay ? this.activityServices.pauseVideo() : this.activityServices.playVideo()
    $('#nextButton').attr('tabindex', 0)

  }
  audioOnOffClick():void{
    this.activityServices.isVideoMuted = this.activityServices.isVideoMuted ? false : true;
    this.activityServices.isVideoMuted ? this.activityServices.muteVideo() : this.activityServices.unMuteVideo();
  }
}
